import React, { useState, useContext, /* useEffect,*/ useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { AppContext, LayoutContext } from '../common/contexts';
import {
    // PLACEHOLDER_FIELD_NAME,
    PLACEHOLDER_FIELD_COUNTRY,
    PLACEHOLDER_FIELD_STATE,
    PLACEHOLDER_FIELD_CITY,
    // PLACEHOLDER_FIELD_EMPLOYMENT_TYPE,
    PLACEHOLDER_FIELD_SALARY_RANGE,
    PLACEHOLDER_FIELD_OCCUPATION,
    // PLACEHOLDER_FIELD_SKILLSET,
    // PLACEHOLDER_FIELD_EDUCATION,
    PLACEHOLDER_FIELD_OTHER_EDUCATION,
    // PLACEHOLDER_FIELD_ABOUT_ME,
    getStateLovPlaceholder,
    getCityLovPlaceholder,
} from '../common/placeholderHelper';
import { getStateLabelByCountryName } from '../common/locationHelper';
import useCountryStateCity from '../common/hooks/useCountryStateCity';
import { setClassNameInDefns } from '../common/definitionHelper';
import { saveSamplePage } from '../common/services/dashboardServices';

import AfitdTypography from '../common/elemental/AfitdTypography';
import AfitdButton from '../common/elemental/AfitdButton';
// import AfitdAutocompleteLite from '../common/elemental/AfitdAutocompleteLite';
import AfitdAutocompleteLiteCreatable from '../common/elemental/AfitdAutocompleteLiteCreatable';
import AfitdSalaryRangeAutocomplete from '../common/elemental/AfitdSalaryRangeAutocomplete';
import AfitdCountryAutocomplete from '../common/elemental/AfitdCountryAutocomplete';
import AfitdStateAutocomplete from '../common/elemental/AfitdStateAutocomplete';
import AfitdCityAutocomplete from '../common/elemental/AfitdCityAutocomplete';

import cx from 'clsx';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

const useStyles = makeStyles(theme => ({
    root: {
        background: '#fff',
        width: '100%',
        height: '100%',
    },
    myPageGridContainer: {
        height: '100%',
    },
    mySectionGridItem: {
        padding: '32px',
        overflowY: 'scroll',
        height: '100%',
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            background: 'none',
        },
        '&::-webkit-scrollbar': {
            width: '8px',
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(0,0,0,0.2)',
        },
    },
    chipBox: {
        marginTop: '10px',
        display: 'flex',
        flexWrap: 'wrap',
    },
    tempBorder: {
        border: '1px solid red',
    },
    chip: {
        margin: '2px',
        borderRadius: '0!important',
    },
}));

const getDefns = params => {
    const {
        classes,
        // userId,
        isConfirmCloseDialogOpen,
        setIsConfirmCloseDialogOpen,
        lovs,
        countryLov,
        stateLov,
        cityLov,
        country,
        setCountry,
        state,
        setState,
        city,
        setCity,
        // cityLocation,
        setCityLocation,
        salaryRange,
        setSalaryRange,
        occupation,
        setOccupation,
        otherEducation,
        setOtherEducation,
        handleClickSaveButton,
    } = params;
    const { chipBox: chipBoxCls, tempBorder: tempBorderCls } = classes;

    const chipData = [
        { key: 0, label: 'Angular' },
        { key: 1, label: 'jQuery' },
        { key: 2, label: 'Polymer' },
        { key: 4, label: 'Vue.js' },
    ];

    const myCondition = true;
    // const countryLov = _get(lovs, 'countryLov', []);
    const occupationLov = _get(lovs, 'occupationLov', []);
    const otherEducationLov = _get(lovs, 'otherEducationLov', []);

    const stateDisabled = !country;
    const cityDisabled = !state || !country;
    const stateLabelValue = getStateLabelByCountryName(country);

    let statePlaceholder = stateDisabled ? '' : getStateLovPlaceholder(stateLov, PLACEHOLDER_FIELD_STATE);
    let cityPlaceholder = cityDisabled ? '' : getCityLovPlaceholder(cityLov, PLACEHOLDER_FIELD_CITY);

    const defns = {
        myPageGridContainer: {
            container: true,
        },
        mySectionGridItem: {
            item: true,
            lg: 12,
            md: 12,
            sm: 12,
            xs: 12,
        },
        chipBox: {
            className: cx(chipBoxCls, { [tempBorderCls]: myCondition }), // if conditional classes are needed
        },
        chipList: {
            chipData,
        },
        tempText: {
            variant: 'body2',
            clsLightBold: true,
            clsPrimaryColor: true,
        },
        tempButton: {
            label: 'My Button',
            color: 'primary',
            onClick: _noop,
        },
        cancelButton: {
            label: 'Cancel',
            onClick: handleClickCancelButton.bind(null, setIsConfirmCloseDialogOpen),
        },
        confirmCloseDialog: {
            open: isConfirmCloseDialogOpen,
            onClose: handleCloseConfirmCloseDialog.bind(null, setIsConfirmCloseDialogOpen),
        },
        confirmCloseDialogCancelButton: {
            // color: 'secondary',
            onClick: handleCloseConfirmCloseDialog.bind(null, setIsConfirmCloseDialogOpen),
        },
        confirmCloseDialogOkButton: {
            // color: 'secondary',
            autoFocus: true,
            onClick: handleClickConfirmCloseDialogYes.bind(null, /*closeDialog,*/ setIsConfirmCloseDialogOpen),
        },
        country: {
            options: countryLov,
            placeholder: PLACEHOLDER_FIELD_COUNTRY,
            value: country,
            onChange: handleChangeCountry.bind(null, setCountry, setState, setCity, setCityLocation),
        },
        stateLabel: {
            value: stateLabelValue,
        },
        state: {
            options: stateLov,
            placeholder: statePlaceholder,
            value: state,
            onChange: handleChangeState.bind(null, setState, setCity, setCityLocation),
            disabled: stateDisabled,
        },
        city: {
            isCapitalize: true,
            noOptionsText: 'Type and select city',
            options: cityLov,
            placeholder: cityPlaceholder,
            value: city,
            onChange: handleChangeCity.bind(null, setCity, setCityLocation),
            disabled: cityDisabled,
        },
        salaryRange: {
            // options: salaryRangeLov, // SalaryRangeLov component comes with its own options
            placeholder: PLACEHOLDER_FIELD_SALARY_RANGE,
            value: salaryRange,
            onChange: handleChangeLovField.bind(null, setSalaryRange),
        },
        occupation: {
            noOptionsText: 'Type and select occupation(s)',
            options: occupationLov,
            placeholder: PLACEHOLDER_FIELD_OCCUPATION,
            isMulti: true,
            value: occupation,
            onChange: handleChangeMultiLovField.bind(null, setOccupation),
        },
        otherEducation: {
            noOptionsText: 'Type and select other education',
            options: otherEducationLov,
            placeholder: PLACEHOLDER_FIELD_OTHER_EDUCATION,
            isMulti: true,
            value: otherEducation,
            onChange: handleChangeMultiLovField.bind(null, setOtherEducation),
        },
        saveButton: {
            color: 'secondary',
            onClick: handleClickSaveButton,
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickCancelButton = setIsConfirmCloseDialogOpen => {
    setIsConfirmCloseDialogOpen(true);
};

const handleCloseConfirmCloseDialog = setIsConfirmCloseDialogOpen => {
    setIsConfirmCloseDialogOpen(false);
};

const handleClickConfirmCloseDialogYes = (/*closeDialog,*/ setIsConfirmCloseDialogOpen) => {
    setIsConfirmCloseDialogOpen(false);
    // closeDialog();
};

const handleChangeLovField = (setField, evt, option) => {
    setField(option);
};

const handleChangeMultiLovField = (setField, evt, options) => {
    setField(options);
};

const handleChangeCountry = (setField, setState, setCity, setCityLocation, evt, option) => {
    setField(option?.name);
    setState(null);
    setCity(null);
    setCityLocation(null);
};

const handleChangeState = (setField, setCity, setCityLocation, evt, option) => {
    setField(option?.name);
    setCity(null);
    setCityLocation(null);
};

const handleChangeCity = (setField, setCityLocation, evt, option) => {
    // City is a single-select creatable. Do not extract the name because the option can potentially be:
    //   { name, location }
    //   { inputValue, name, label }  (service will need inputValue to inserting the new value in db)
    setField(option);
    setCityLocation(option?.location || null);
};

const SamplePage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const classes = useStyles();
    const context = useContext(LayoutContext);
    const userId = _get(context, 'userId');
    const appContext = useContext(AppContext);
    const lovs = _get(appContext, 'lovs');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [isConfirmCloseDialogOpen, setIsConfirmCloseDialogOpen] = useState(false);
    const {
        countryLov,
        stateLov,
        // setStateLov,
        cityLov,
        // setCityLov,
        country,
        setCountry,
        state,
        setState,
        city,
        setCity,
        cityLocation,
        setCityLocation,
    } = useCountryStateCity({
        defaultCountryLov: _get(lovs, 'countryLov', []),
    }); // custom hook for local states for the location fields/LOV's
    const [salaryRange, setSalaryRange] = useState();
    const [occupation, setOccupation] = useState();
    const [otherEducation, setOtherEducation] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    const handleClickSaveButton = useCallback(() => {
        saveSamplePage({
            userId,
            country,
            state,
            city,
            cityLocation,
            salaryRange,
            occupation,
            otherEducation,
        });
    }, [userId, country, state, city, cityLocation, salaryRange, occupation, otherEducation]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        classes,
        // userId,
        isConfirmCloseDialogOpen,
        setIsConfirmCloseDialogOpen,
        lovs,
        countryLov,
        stateLov,
        cityLov,
        country,
        setCountry,
        state,
        setState,
        city,
        setCity,
        cityLocation,
        setCityLocation,
        salaryRange,
        setSalaryRange,
        occupation,
        setOccupation,
        otherEducation,
        setOtherEducation,
        handleClickSaveButton,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div {...defns.root}>
            <Grid {...defns.myPageGridContainer}>
                <Grid {...defns.mySectionGridItem}>
                    <div>Override 'chipBox' styles by adding 'tempBorder' class</div>
                    <div {...defns.chipBox}>
                        <ChipList {...defns.chipList} />
                    </div>
                    <br />
                    <AfitdTypography {...defns.tempText}>Using AfitdTypography</AfitdTypography>
                    <br />
                    <div>Using AfitdButton</div>
                    <AfitdButton {...defns.tempButton} />
                    <br />
                    <br />
                    <AfitdButton {...defns.cancelButton} />
                    <br />
                    <br />
                    <div>Country</div>
                    <AfitdCountryAutocomplete {...defns.country} />
                    <br />
                    <div>{defns.stateLabel?.value}</div>
                    <AfitdStateAutocomplete {...defns.state} />
                    <br />
                    <div>City</div>
                    <AfitdCityAutocomplete {...defns.city} />
                    <br />
                    <div>Salary Range</div>
                    <AfitdSalaryRangeAutocomplete {...defns.salaryRange} />
                    <br />
                    <div>Occupation</div>
                    <AfitdAutocompleteLiteCreatable {...defns.occupation} />
                    <br />
                    <div>Other Education</div>
                    <AfitdAutocompleteLiteCreatable {...defns.otherEducation} />
                    <br />
                    <AfitdButton {...defns.saveButton}>Save</AfitdButton>
                </Grid>
            </Grid>
            <Dialog aria-labelledby="confirm-close-dialog" aria-describedby="confirm-close-dialog" {...defns.confirmCloseDialog}>
                <DialogTitle id="alert-dialog-title">Cancel?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">All unsaved changes will be lost.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <AfitdButton {...defns.confirmCloseDialogCancelButton}>No</AfitdButton>
                    <AfitdButton {...defns.confirmCloseDialogOkButton}>Yes</AfitdButton>
                </DialogActions>
            </Dialog>
        </div>
    );
    //---------------------------------------------------------------------
};

// Quick sub-component
const ChipList = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const classes = useStyles();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { chipData } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    // const defns = {};
    // setClassNameInDefns(defns, classes);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return chipData.map(data => <FilterChip data={data} />);
    //---------------------------------------------------------------------
};

// Quick sub-component
const FilterChip = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const classes = useStyles();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { data } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const label = _get(data, 'label');
    const defns = {
        chip: {
            // icon: icon,
            label,
            onDelete: label === 'React' ? undefined : _noop,
        },
    };
    setClassNameInDefns(defns, classes);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div key={data.key}>
            <Chip {...defns.chip} />
        </div>
    );
    //---------------------------------------------------------------------
};

export default SamplePage;
